import * as React from 'react';

function SvgEdit(props: ISvgIcons) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size}
      height={props.size}
      viewBox={'0 0 24 24'}
      {...props}
    >
      <path
        d="M22.19 1.81a3.637 3.637 0 00-5.17.035l-14.5 14.5L.75 23.25l6.905-1.771 14.5-14.5a3.636 3.636 0 00.035-5.169zm-5.584.45l5.134 5.134m-19.219 8.95l5.139 5.13"
        stroke={props.color}
        strokeWidth={props.weight}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={'non-scaling-stroke'}
      />
    </svg>
  );
}

export default SvgEdit;
